<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Employee Plan Status</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row justify="center" class="no-display" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                            item-text="name" item-value="id" label="Salary Year" outlined @change="getSalaryMonth()" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
                            :items="sal_month_list" item-text="sal_mon" item-value="id" label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="emp_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type"
                            outlined />
                    </v-col>
                    <v-col cols="12" sm="8" md="5" v-if="sal_month != null" align="center">
                        <!-- <center> -->
                        <v-btn class="button" @click="fetchReport()" :loading="loader">Employee Attendance
                            Status</v-btn>
                        <!-- </center> -->
                    </v-col>
                </v-row>
                <v-row dense>
                    <!-- <v-col cols="12" sm="3" md="3">
            <v-btn
              color="success"
              outlined
              rounded
              v-if="attendance_details.length != 0"
            >
              <download-excel
                class="mr-2 pb-3 pt-2"
                :data="attendance_details"
                :fields="table_fields"
                worksheet="EmployeePlanDetailedReport"
                name="EmployeePlanDetailedReport.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn>
          </v-col> -->
                    <!-- export btn code -->
                    <v-col cols="6" sm="2" md="2">
                        <v-btn class="ma-2 no-display " rounded color="success" outlined
                            v-if="attendance_details.length != 0"
                            @click="fnExcelReport('my-table-id', 'EmployeePlanDetailedReport')"
                            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="6" sm="2" md="2">
                        <v-btn class="ma-2 no-display " rounded tile v-if="attendance_details.length != 0" outlined
                            color="warning" @click="print()">
                            <v-icon class="mt-1 mb-1">mdi-printer</v-icon> Print <v-icon right></v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile v-if="attendance_details.length != 0" outlined
                            color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>

                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- header code -->
                        <v-simple-table></v-simple-table>
                        <div v-if="attendance_details.length != 0">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo"
                                    align="center">
                                    <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                </v-col>
                                <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2>
                                        <h3>
                                            <strong>{{ org_basic_data.school_name }} </strong>
                                        </h3>
                                        <span>{{ org_basic_data.address }}</span> <br />
                                        <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                        <span>Email :{{ org_basic_data.email }} </span> <br />
                                        <span>Website :{{ org_basic_data.website }} </span>
                                        <br />
                                    </center>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                    <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                </v-col>
                            </v-row>
                        </div>

                        <v-row dense justify="center" v-if="attendance_details!=''">
                            <v-col cols="12" sm="2" md="2"><strong>H:Holiday</strong></v-col>
                            <v-col cols="12" sm="2" md="2"><strong>WO:Weekly Off</strong></v-col>
                            <v-col cols="12" sm="2" md="2"><strong>L:Leave</strong></v-col>
                            <v-col cols="12" sm="2" md="2"><strong>X:Plan Not Applied</strong></v-col>
                            <v-col cols="12" sm="2" md="2"><strong>--:In Out Not Marked</strong></v-col>
                            <v-col cols="12" sm="2" md="2"><strong><v-icon small class="mr-2 v-icon-size"
                                        color="success">mdi-check-circle-outline</v-icon>:In Out Marked</strong></v-col>
                        </v-row>
                        <div id="my-table-id">
                            <v-simple-table fixed-header dense class="elevation-1" v-if="attendance_details!=''">
                                <thead>
                                    <tr>
                                        <th class="">Sr. No.</th>
                                        <th class="">Employee</th>
                                        <th v-for="(s, index) in daysArray" :key="index">
                                            {{ s }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- :class="s.isweeklyoff ? 'weaklyoff2' : 'weaklyoff'" -->
                                    <tr v-for="(s, index) in attendance_details" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ s.inst_name }}</td>
                                        <th v-for="(a, index1) in s.att_data" :key="index1"
                                            :class="a=='WO' ? 'weaklyoff2' : 'weaklyoff'">
                                            <span v-if="a=='P'">
                                                <v-icon small class="mr-2 v-icon-size"
                                                    color="success">mdi-check-circle-outline</v-icon>
                                            </span>
                                            <span v-else>
                                                {{ a }}
                                            </span>
                                        </th>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: null,
            year: null,
            year_list: [],
            freez_flag: null,
            fmsg: null,
            employee_list: [],
            emp: null,
            show_logo: true,
             org_basic_data: [],
            attendance_details: [],
            inst_data:[],
            daysArray:[],
            employee_type_list:[],
            emp_type:null,
            //   table_fields: {
            //  Name: "H:Holiday",
            //          "Weekly Off": "WO:Weekly Off",
            //         "Leave": "L:Leave",
            //          "Plan Not Applied": "X:Plan Not Applied",
            //          "In Out Not Marked":"--:In Out Not Marked",
                    //   },
        }),
        methods: {
             print() {
                 this.$store.state.drawer = false;
                let that = this;
              window.onafterprint = function () {
                 that.$store.state.drawer = true;
                 };
               setTimeout(function () {
                 window.print();
                 }, 100);
              },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                 const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            showLogo() {
                if (this.show_logo) {
                    this.show_logo = false;
                } else {
                    this.show_logo = true;
                }
            },
            fetchReport() {
                const data = {
                    sal_month: this.sal_month,
                    emp_type:this.emp_type
                };
                this.loader = true;
                axios
                    .post("/EmployeeBiometric/getEmployeePlanDetailedReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.attendance_details = res.data.attendance_details;
                            this.daysArray = res.data.daysArray;
                             this.org_basic_data = res.data.org_basic_data;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
           
            onLoad() {
                axios
                    .post("/Payroll/getYear")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.year_list = res.data.year_list;
                            this.employee_list = res.data.inst_list;
                            this.employee_type_list = res.data.employee_type_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getSalaryMonth() {
                const data = {
                    year: this.year,
                };
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */


    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    .weaklyoff {
        background: white !important;
    }
    .weaklyoff2 {
        background: yellow !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    @media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  table,
  td,
  tr {
    break-inside: avoid-page;
  }

  /* img {
    width: 100% !important;
  } */
  .scroll {
    overflow-x: hidden;
  }

  body,
  tr,
  th,
  td,
  center {
    font-size: 14pt !important;
    font-weight: bold !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }

  

  @page {
    size: A4;
    /*margin: 0px; */
    /* padding: 0px; */
    /* size: 15.5in 15.5in; */
    margin-top: none;
    padding-top: none;
    size: 25in 19in;
  }

  .table-data {
    height: 100% !important;
    overflow-x: hidden;
    overflow-y: hidden !important;
  }

  .box {
    /* height: 100% !important; */
    overflow-x: hidden;
    border: none !important;
  }
}
.trust-logo {
    width: 86%;
  }

  .schl-logo {
    width: 86%;
  }
</style>
